import * as React from 'react';
import './AllocatedWPsPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as AllocatedWPActions from '../../../actions/allocatedWPs';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface IAllocatedWPsPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  allocatedWP: Dtos.AllocatedWP[];
  loadingAllocatedWPs: boolean;
  loadAllocatedWPsSuccess: boolean;
  loadAllocatedWPsFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface IAllocatedWPsPageActions {
  clearAllocatedWPs: AllocatedWPActions.IAllocatedWPClearActionCreator;
  loadAllocatedWPs: AllocatedWPActions.IAllocatedWPLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: AllocatedWPActions.IAllocatedWPFilterActionCreator;
}
type AllocatedWPsPageProps = IAllocatedWPsPageProps & IAllocatedWPsPageActions;
class AllocatedWPsPage extends React.PureComponent<AllocatedWPsPageProps, any> {
  constructor(props: AllocatedWPsPageProps) {
    super(props);
    this.clearAllocatedWPs = this.clearAllocatedWPs.bind(this);
  }
  componentDidMount() {
    const {
      loadAllocatedWPs
    } = this.props;
    loadAllocatedWPs();
  }
  componentWillReceiveProps(nextProps: AllocatedWPsPageProps) {}
  componentDidUpdate(prevProps: AllocatedWPsPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: AllocatedWPsPageProps) {}
  componentWillUnmount() {
    this.clearAllocatedWPs();
  }
  clearAllocatedWPs() {
    this.props.clearAllocatedWPs();
  }
  showAllocatedWPs(): boolean {
    const {
      loadingAllocatedWPs,
      loadAllocatedWPsSuccess
    } = this.props;
    if (!loadingAllocatedWPs && loadAllocatedWPsSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingAllocatedWPs
    } = this.props;
    return <TrialLookupsLayout loading={loadingAllocatedWPs} permission={Dtos.Permission.AllocatedWPsView} data-sentry-element="TrialLookupsLayout" data-sentry-component="AllocatedWPsPage" data-sentry-source-file="AllocatedWPsPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Allocated WPs</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.AllocatedWPsCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/allocatedwps/create"}>Create</Link>}
                </div>
            </div>
            {!this.showAllocatedWPs() ? "Loading Allocated WPs" : null}
            {this.showAllocatedWPs() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      allocatedWP
    } = this.props;
    if (!allocatedWP || allocatedWP.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no allocated WPs to view.</span>
            </div>;
    }
    const showPagination = allocatedWP.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={allocatedWP} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : allocatedWP.length} pageSize={showPagination ? undefined : allocatedWP.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no allocatedWP to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/allocatedwps/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: AllocatedWPsPageProps): IAllocatedWPsPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.allocatedWPs.formFilter,
    allocatedWP: state.allocatedWPs.formFilteredData,
    loadingAllocatedWPs: state.allocatedWPs.loadState && state.allocatedWPs.loadState.status == RequestState.Pending,
    loadAllocatedWPsSuccess: state.allocatedWPs.loadState && state.allocatedWPs.loadState.status == RequestState.Success,
    loadAllocatedWPsFailure: state.allocatedWPs.loadState && state.allocatedWPs.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): IAllocatedWPsPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadAllocatedWPs: bindActionCreators(AllocatedWPActions.LoadAllocatedWP, dispatch),
    clearAllocatedWPs: bindActionCreators(AllocatedWPActions.Clear, dispatch),
    filter: bindActionCreators(AllocatedWPActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AllocatedWPsPage);